/**
 * Ensures that a URL has a protocol (http:// or https://)
 * If no protocol is present, adds https:// by default
 * @param url - The URL to ensure has a protocol
 * @returns The URL with a protocol
 */
export const ensureUrlProtocol = (url: string): string => {
    if (!url) return url;
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    return `https://${url}`;
};
